import React, { useEffect, useRef } from "react";
import { FlexCenter } from "../../layout/FlexCenter/FlexCenter";
import { PanelLayout } from "../../layout/Panel/Panel";
import { Spacing } from "../../layout/Spacing/Spacing";

interface IMenuButtonsProps {
    children: React.ReactNode;
    width?: number;
    bottom?: number;
    left?: number;
    right?: number;
    top?: number;
    hasTop?: boolean;
    hasRight?: boolean;
    setShowMenu: React.Dispatch<React.SetStateAction<boolean>>;
    showMenu: boolean;
}

export const MenuButtons:React.FC<IMenuButtonsProps> = ({
    children,
    width = 160,
    bottom = 50,
    left = 10,
    top = 0,
    right = 0,
    hasTop = false,
    hasRight = false,
    showMenu,
    setShowMenu
}) => {

        const menuRef = useRef<HTMLDivElement>(null);
        
        useEffect(() => {
            const handleClickOutside = (event: MouseEvent) => {
                if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                    setShowMenu(false);
                }
            };
        
            if (showMenu) {
                document.addEventListener('mousedown', handleClickOutside);
            }
        
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, [setShowMenu, showMenu]);

    return (   
        <>
        {
            showMenu &&
                
                <div
                    ref={menuRef}
                    style={{
                        position: 'absolute',
                        zIndex: 3,
                        width: `${width}px`,
                        ...(hasRight ? { right: `${right}px` } : { left: `${left}px` }),
                        ...(hasTop ? { top: `${top}px` } : { bottom: `${bottom}px` })
                    }}
                >
                    <PanelLayout hasShadow borderIntensity={.1} color="grey-light">
                        <Spacing marginSpacing="none" paddingSpacing="m">
                            <FlexCenter direction="h" position="start" gap={0.5}>
                                {children}
                            </FlexCenter>
                        </Spacing>
                    </PanelLayout>
                </div>
        }
        </> 

    );
};

